import { render, staticRenderFns } from "./Revision.vue?vue&type=template&id=2581a355&scoped=true"
import script from "./Revision.vue?vue&type=script&lang=js"
export * from "./Revision.vue?vue&type=script&lang=js"
import style0 from "./Revision.vue?vue&type=style&index=0&id=2581a355&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2581a355",
  null
  
)

export default component.exports